/* Aza Arcade leaderboard client. Games call AzaBoard.start(game) when a round begins and
   AzaBoard.finish({ game, score, keeper, ranked }) on the results screen. */
(() => {
  'use strict';
  const runs = {};
  const panel = (game) => document.querySelector('[data-aza-board][data-game="' + game + '"]');
  // Shopify's t filter HTML-escapes translations (it's -> it&#39;s); decode before using them as text
  const ta = document.createElement('textarea');
  const unesc = (v) => typeof v === 'string' ? (v.indexOf('&') < 0 ? v : (ta.innerHTML = v, ta.value)) : Array.isArray(v) ? v.map(unesc) : v && typeof v === 'object' ? Object.fromEntries(Object.entries(v).map(([k, x]) => [k, unesc(x)])) : v;
  const strings = (el) => { try { return unesc(JSON.parse(el.querySelector('[data-lb-i18n]').textContent)); } catch (e) { return {}; } };
  const api = (el, path, body) => fetch(el.dataset.url.replace(/\/+$/, '') + path, body ? {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
  } : undefined).then((r) => r.json());
  const fmt = (n) => Math.round(n).toLocaleString();

  const render = (el, rows, mine) => {
    const T = strings(el), list = el.querySelector('[data-lb-list]');
    list.innerHTML = '';
    if (!rows || !rows.length) {
      const li = document.createElement('li'); li.className = 'z-lb-empty'; li.textContent = T.empty || ''; list.appendChild(li); return;
    }
    rows.forEach((r, i) => {
      const li = document.createElement('li');
      if (mine && r.name === mine.name && r.score === mine.score) li.className = 'z-lb-me';
      const n = document.createElement('span'); n.className = 'z-lb-n'; n.textContent = i + 1;
      const name = document.createElement('span'); name.className = 'z-lb-name'; name.textContent = r.name;
      if (r.keeper) name.dataset.keeper = r.keeper;
      const sc = document.createElement('b'); sc.textContent = fmt(r.score);
      li.append(n, name, sc); list.appendChild(li);
    });
  };
  const load = (el, game) => {
    const T = strings(el), msg = el.querySelector('[data-lb-msg]');
    return api(el, '/top?game=' + encodeURIComponent(game)).then((d) => { render(el, d.top); return d.top || []; })
      .catch(() => { msg.textContent = T.err_net || ''; return null; });
  };

  // view-only boards (arcade hub) load as soon as the page is ready
  const autoload = () => document.querySelectorAll('[data-lb-autoload]').forEach((el) => {
    const msg = el.querySelector('[data-lb-msg]');
    msg.textContent = strings(el).loading || '';
    load(el, el.dataset.game).then((rows) => { if (rows !== null) msg.textContent = ''; });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoload); else autoload();

  window.AzaBoard = {
    start(game) {
      const el = panel(game);
      if (!el) return;
      runs[game] = api(el, '/start', { game }).then((d) => (d && d.token) || null).catch(() => null);
    },
    finish({ game, score, keeper, ranked }) {
      const el = panel(game);
      if (!el) return;
      const T = strings(el);
      const form = el.querySelector('[data-lb-form]'), msg = el.querySelector('[data-lb-msg]');
      const input = el.querySelector('[data-lb-name]'), btn = el.querySelector('[data-lb-submit]');
      const token = runs[game]; runs[game] = null;
      msg.textContent = T.loading || ''; form.hidden = true;
      load(el, game).then((rows) => {
        if (rows === null) return;
        msg.textContent = '';
        if (!ranked) { msg.textContent = T.paused || ''; return; }
        if (!score) return;
        const qualifies = rows.length < 20 || score > rows[rows.length - 1].score;
        if (!qualifies) { msg.textContent = T.off || ''; return; }
        form.hidden = false;
        try { input.value = localStorage.getItem('aza-arcade-name') || ''; } catch (e) { /* storage blocked */ }
      });
      el.querySelector('[data-lb-alias]').onclick = () => {
        const a = (T.alias_a || 'Nova').split(','), b = (T.alias_b || 'Runner').split(',');
        input.value = a[Math.floor(Math.random() * a.length)] + b[Math.floor(Math.random() * b.length)] + Math.floor(10 + Math.random() * 90);
        input.focus();
      };
      form.onsubmit = (e) => {
        e.preventDefault();
        const name = input.value.replace(/\s+/g, ' ').trim();
        if (!/^[\p{L}\p{N} _-]{3,16}$/u.test(name)) { msg.textContent = T.err_name || ''; input.focus(); return; }
        btn.disabled = true; msg.textContent = T.sending || '';
        Promise.resolve(token).then((tk) => {
          if (!tk) throw new Error('net');
          return api(el, '/submit', { token: tk, name, score, keeper });
        }).then((d) => {
          if (d.ok) {
            try { localStorage.setItem('aza-arcade-name', name); } catch (err) { /* storage blocked */ }
            form.hidden = true;
            msg.textContent = d.rank <= 20 ? (T.rank || '').replace('__N__', d.rank) : (T.off || '');
            render(el, d.top, { name, score });
            return;
          }
          btn.disabled = false;
          msg.textContent = d.error === 'name' ? T.err_name : d.error === 'rate' ? T.err_rate : d.error === 'score' || d.error === 'used' || d.error === 'token' || d.error === 'expired' ? T.err_score : T.err_net;
          if (d.error !== 'name') form.hidden = true;
        }).catch(() => { btn.disabled = false; msg.textContent = T.err_net || ''; });
      };
    }
  };
})();
